export const ADA_METADATA = {
    policyId: "",
    assetName: "43415244414e4f",
    ticker: "ADA",
    assetId: "ada.lovelace",
    decimals: 6,
};
export const dAppConnectorInstance = {
    ref: undefined,
};
//# sourceMappingURL=cardano.js.map